import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import PlansContainerTopHeader from "./PlansContainerTopHeader";
import PlansContainerFooter from "./PlansContainerFooter";
import PlansList from "./PlansList";

export default function PlansContainer() {
    const [yearlySelected, setYearlySelected] = useState(false);

    const userPlanDetails = useSelector(
        (state) => state?.userPlan?.userPlanDetails?.[0]
    );

    useEffect(() => {
        if (!userPlanDetails) return;

        if (userPlanDetails.plan_id === 7) {
            setYearlySelected(true);
        }

        else if (userPlanDetails.plan_id === 6) {
            setYearlySelected(false);
        }
    }, [userPlanDetails]);

    return (
        <>
            <PlansContainerTopHeader
                setYearlySelected={setYearlySelected}
                yearlySelected={yearlySelected}
            />
            <PlansList yearlySelected={yearlySelected} />
            <PlansContainerFooter />
        </>
    );
}
